import { useRef, useEffect } from 'react';

export const useMounted = () => {
  const isMountRef = useRef(true);
  useEffect(() => {
    isMountRef.current = false;
  }, []);
  return !isMountRef.current;
};